import { gql } from 'graphql-request'

export const ListOffersGql = gql`
  query listOffers(
    $currentPage: Int!
    $pageSize: Int!
    $orderBy: ListOffersOrderByOptions!
    $orderByAscending: Boolean!
    $stationRecordNumber: String!
    $offerStatuses: [OfferStatus!]
  ) {
    listOffers(
      request: {
        currentPage: $currentPage
        pageSize: $pageSize
        orderByAscending: $orderByAscending
        orderBy: $orderBy
        stationRecordNumber: $stationRecordNumber
        offerStatuses: $offerStatuses
      }
    ) {
      currentPage
      totalPageCount
      totalResultCount
      results {
        id
        status
        created
        offerFrom
        paymentDate
        expiryDateTime
        completedDateTime
        submittedOnBehalfOfGrower
      }
    }
  }
`
